// extracted by mini-css-extract-plugin
export default {"footerContainer":"DeactivateMultifactorAuthenticationWarningPopup_footerContainer__U4PPg"};